import PropTypes from 'prop-types';

const Graphic = ({view}) => {
	switch (view) {
		case 'e832cbc9-b660-4ec0-aebf-6540a036e54c':
			return (
				<svg
					width="300"
					height="300"
					viewBox="0 0 79.374998 79.375002"
					version="1.1"
					className="worldWater-ViewCard-graphic"
				>
					<g>
						<path
							className="polygon"
							d="M 40.674899,10.014485 C 35.503953,6.4602428 29.059536,4.5603362 22.855749,5.5007346 19.576704,5.9977873 16.426526,7.2702106 13.676612,9.1241712 12.122493,10.17194 10.681266,11.416492 9.5769617,12.930962 8.4726574,14.445432 7.7164382,16.24436 7.6046192,18.11535 c -0.122021,2.041692 0.5135356,4.042293 0.8258848,6.063637 0.1561746,1.010672 0.2316024,2.042755 0.090543,3.055647 -0.1410593,1.012893 -0.509205,2.010352 -1.1645151,2.795474 -0.9278319,1.111629 -2.3243051,1.697812 -3.4974237,2.546566 -1.2544134,0.907571 -2.2843238,2.169056 -2.7474506,3.64647 -0.23156335,0.738707 -0.31919652,1.524774 -0.23185531,2.293982 0.0873412,0.769208 0.35152231,1.520577 0.78493781,2.162029 0.4382897,0.648666 1.0411062,1.175592 1.7062174,1.588499 0.6651111,0.412907 1.3929065,0.715916 2.1333314,0.970152 1.4808499,0.508473 3.0347145,0.832798 4.4309299,1.541348 1.8077261,0.917383 3.2773901,2.469812 4.1345701,4.30685 0.97325,2.085792 1.155883,4.460121 1.011325,6.757259 -0.144558,2.297139 -0.598865,4.563249 -0.839045,6.852366 -0.299849,2.85781 -0.238573,5.864899 1.03364,8.44142 1.065292,2.157459 2.950607,3.878683 5.157886,4.83649 2.207279,0.957806 4.717197,1.163152 7.073554,0.67627 2.200122,-0.4546 4.240018,-1.484012 6.162166,-2.647002 1.922148,-1.162989 3.757275,-2.470265 5.724724,-3.554858 3.693622,-2.036177 7.845505,-3.261151 12.05916,-3.44548 4.19283,-0.183418 8.406349,0.649313 12.57599,0.17228 2.497236,-0.285699 5.013316,-1.085356 6.890945,-2.75638 1.296786,-1.154094 2.24476,-2.705767 2.631053,-4.39821 0.386292,-1.692444 0.200451,-3.51815 -0.563773,-5.07685 -0.833115,-1.699209 -2.279016,-3.00017 -3.5162,-4.432219 -0.618592,-0.716025 -1.194076,-1.478652 -1.607524,-2.329773 -0.413448,-0.851122 -0.660113,-1.798533 -0.596541,-2.742623 0.06967,-1.034638 0.509859,-2.021482 1.129864,-2.852699 0.620005,-0.831217 1.414274,-1.517871 2.251283,-2.130034 1.674019,-1.224327 3.570285,-2.20177 4.923228,-3.773667 1.126161,-1.308414 1.80393,-2.962317 2.120489,-4.659366 0.316559,-1.697049 0.287112,-3.442121 0.119071,-5.160244 -0.294207,-3.008097 -1.030634,-6.021023 -2.58411,-8.61369 -1.258086,-2.099677 -3.051325,-3.891707 -5.20494,-5.05505 -1.400257,-0.756393 -2.958423,-1.246984 -4.548775,-1.307208 -1.590353,-0.06022 -3.212291,0.324143 -4.545,1.194048 -1.009595,0.658998 -1.827629,1.571646 -2.566067,2.524678 -0.738438,0.953032 -1.410865,1.95833 -2.199548,2.870218 -0.788683,0.911888 -1.710277,1.738498 -2.812756,2.226454 -0.55124,0.243977 -1.143982,0.400104 -1.746017,0.430818 -0.602036,0.03072 -1.213376,-0.06596 -1.765866,-0.30709 -1.025524,-0.447587 -1.78226,-1.35609 -2.339576,-2.326364 -0.557316,-0.970275 -0.952493,-2.025761 -1.49319,-3.005394 -1.242612,-2.251361 -3.211151,-4.022997 -5.33034,-5.479619 z"
						/>
						<g transform="matrix(1.3535537,0,0,1.3602934,-77.379256,-47.489727)">
							<path
								className="line"
								d="M 103.18749,80.470941 69.511534,46.79498"
							/>
							<path
								className="line"
								d="m 103.18749,76.729169 v 3.741772 l -3.741774,4e-6"
							/>
							<path
								className="line"
								d="m 73.253305,46.794983 -3.741771,-3e-6 -5e-6,3.741778"
							/>
						</g>
						<g transform="matrix(0,1.3535537,-1.3602934,0,131.81083,-73.30546)">
							<path
								className="line"
								d="M 103.18749,80.470941 69.511534,46.79498"
							/>
							<path
								className="line"
								d="m 103.18749,76.729169 v 3.741772 l -3.741774,4e-6"
							/>
							<path
								className="line"
								d="m 73.253305,46.794983 -3.741771,-3e-6 -5e-6,3.741778"
							/>
						</g>
					</g>
				</svg>
			);
		case 'a969ad80-887c-47d4-9d98-0e2fb747fcc7':
			return (
				<svg
					width="300"
					height="300"
					viewBox="0 0 79.374998 79.375002"
					version="1.1"
					className="worldWater-ViewCard-graphic"
				>
					<g transform="translate(-2.6458333)">
						<rect
							className="line"
							width="18.520834"
							height="76.729164"
							x="2.6458333"
							y="2.6458333"
							rx="1.8520833"
							ry="1.8520833"
						/>
						<path className="line" d="M 21.166666,7.9374999 H 10.583333" />
						<path className="line" d="M 21.166666,11.90625 H 15.875" />
						<path className="line" d="M 21.166666,15.875 H 15.875" />
						<path className="line" d="M 21.166666,19.84375 H 10.583333" />
						<path className="line" d="M 21.166666,23.8125 H 15.875" />
						<path className="line" d="M 21.166666,27.78125 H 15.875" />
						<path className="line" d="M 21.166666,31.75 H 10.583333" />
						<path className="line" d="M 21.166666,35.71875 H 15.875" />
						<path className="line" d="M 21.166666,39.6875 H 15.875" />
						<path className="line" d="M 21.166666,43.656249 H 10.583333" />
						<path className="line" d="M 21.166666,47.624999 H 15.875" />
						<path className="line" d="M 21.166666,51.593749 H 15.875" />
						<path className="line" d="M 21.166666,55.562499 H 15.875" />
					</g>
					<g>
						<path
							className="polygon"
							d="M -1e-6,52.916667 0,46.302083 c 6.6145833,0 8.2989469,6.614583 13.229166,6.614583 4.930219,0 8.298948,-6.614583 13.229167,-6.614583 4.930219,0 8.298948,6.614583 13.229167,6.614583 4.930219,0 8.298947,-6.614583 13.229166,-6.614583 4.930219,0 8.298947,6.614583 13.229166,6.614583 4.930219,0 8.298948,-6.614583 13.229167,-6.614583 l 10e-7,6.614583 V 82.020833 H 0 Z"
						/>
						<path
							className="line"
							d="m 1e-6,55.5625 c 4.9302191,0 8.2989469,6.614583 13.229166,6.614583 4.930219,0 8.298948,-6.614583 13.229167,-6.614583 4.930219,0 8.298948,6.614583 13.229167,6.614583 4.930219,0 8.298947,-6.614583 13.229166,-6.614583 4.930219,0 8.298947,6.614583 13.229166,6.614583 4.930218,0 8.298946,-6.614583 13.229164,-6.614583"
						/>
					</g>
					<g>
						<path className="line thick" d="M 39.6875,13.229167 V 34.395833" />
						<path
							className="line thick"
							d="M 33.072916,27.78125 39.6875,34.395833 46.302083,27.78125"
						/>
					</g>
					<g transform="matrix(1,0,0,-1,13.229167,47.625)">
						<path className="line thick" d="M 39.6875,13.229167 V 34.395833" />
						<path
							className="line thick"
							d="M 33.072916,27.78125 39.6875,34.395833 46.302083,27.78125"
						/>
					</g>
				</svg>
			);
		case 'statistics':
			return (
				<svg
					width="300"
					height="300"
					viewBox="0 0 79.374998 79.375002"
					className="worldWater-ViewCard-graphic"
				>
					<path className="line" d="M 12.474557,28.154976 24.56711,38.520023" />
					<path
						className="line"
						d="M 30.568868,38.089152 43.514465,23.294183"
					/>
					<path
						className="line"
						d="M 49.863004,17.819168 61.261989,10.491247"
					/>
					<rect
						className="polygon"
						width="13.229168"
						height="34.395832"
						x="2.6458335"
						y="44.979164"
						rx="1.3229169"
						ry="1.3229166"
					/>
					<rect
						className="line"
						width="13.229169"
						height="18.520834"
						x="21.166666"
						y="60.854168"
						rx="1.3229166"
						ry="1.3229166"
					/>
					<rect
						className="polygon"
						width="13.229167"
						height="39.687504"
						x="39.6875"
						y="39.6875"
						rx="1.3229166"
						ry="1.3229167"
					/>
					<rect
						className="line"
						width="13.229165"
						height="51.593746"
						x="58.208332"
						y="27.78125"
						rx="1.3229166"
						ry="1.3229167"
					/>
					<circle
						className="polygon"
						cx="64.822914"
						cy="8.2020826"
						r="4.2333331"
					/>
					<circle
						className="line"
						cx="46.302082"
						cy="20.108334"
						r="4.2333331"
					/>
					<circle
						className="polygon"
						cx="27.78125"
						cy="41.275002"
						r="4.2333331"
					/>
					<circle className="line" cx="9.260417" cy="25.4" r="4.2333331" />
				</svg>
			);
		case 'riverNetworkAnalysis':
			return (
				<svg
					width="300"
					height="300"
					viewBox="0 0 79.374998 79.375002"
					version="1.1"
					className="worldWater-ViewCard-graphic"
				>
					<path
						className="line superthick"
						d="M 79.374999,79.374999 64.822916,64.822916 47.625,55.5625"
					/>
					<path
						className="line thick"
						d="m 64.822916,64.822916 -7.9375,-19.84375 3.96875,-11.90625"
					/>
					<path
						className="line thick"
						d="M 47.625,55.5625 43.656249,47.624999 29.104166,39.6875 23.8125,26.458333"
					/>
					<path
						className="line thick"
						d="M 47.625,55.5625 33.072916,62.177083 18.520833,58.208333"
					/>
					<path
						className="line"
						d="M 56.885416,44.979166 44.979166,34.395833"
					/>
					<path
						className="line"
						d="M 60.854166,34.395833 62.177083,23.8125 71.437499,13.229167"
					/>
					<path className="line" d="m 62.177083,23.8125 -7.9375,-11.90625" />
					<path
						className="line"
						d="M 23.8125,26.458333 14.552083,13.229167 V 3.96875"
					/>
					<path className="line" d="M 14.552083,13.229167 H 5.2916666" />
					<path
						className="line"
						d="M 23.8125,26.458333 39.6875,19.84375 46.302083,9.2604166"
					/>
					<path
						className="line"
						d="M 39.6875,19.84375 27.78125,10.583333 26.458333,7.9374999"
					/>
					<path
						className="line"
						d="M 29.104166,39.6875 14.552083,37.041666 5.2916666,42.333333"
					/>
					<path
						className="line"
						d="M 29.104166,39.6875 14.552083,37.041666 5.2916666,42.333333"
					/>
					<path className="line" d="M 14.552083,37.041666 7.9374999,27.78125" />
					<path
						className="line"
						d="M 33.072916,62.177083 19.84375,71.437499 6.6145832,70.114582"
					/>
					<path
						className="line"
						d="M 10.583333,47.624999 15.875,48.947916 18.520833,58.208333 13.229167,63.5 3.96875,60.854167"
					/>
					<path
						className="line"
						d="M 64.822916,64.822916 51.593749,71.437499 H 39.6875"
					/>
					<path className="line" d="m 60.854166,33.072916 13.229166,-3.96875" />
					<circle
						className="polygon"
						cx="60.854168"
						cy="33.072918"
						r="4.2333331"
					/>
					<circle className="polygon" cx="63.5" cy="64.822914" r="4.2333331" />
					<circle
						className="polygon"
						cx="46.302082"
						cy="55.5625"
						r="4.2333331"
					/>
					<circle
						className="polygon"
						cx="18.520834"
						cy="58.208332"
						r="4.2333331"
					/>
					<circle
						className="polygon"
						cx="29.104166"
						cy="39.6875"
						r="4.2333331"
					/>
					<path
						className="line"
						d="m 51.593749,25.135416 -1.322916,3.96875 -5.291667,5.291667 -3.968749,0 -5.291667,-3.96875"
					/>
				</svg>
			);
		default:
			return null;
	}
};

Graphic.propTypes = {
	view: PropTypes.string,
};

export default Graphic;
